module.exports = __webpack_public_path__ + "Pe-icon-7-filled.ttf?05951ccf586d27ea7d50e2d3db3eef65";